/**
 * Central builder for session URLs.
 *
 * Previously these were derived with `location.href.replace('/host', '/player')`,
 * which breaks for any path that does not literally contain `/host` (including the
 * Zoom launch route) and silently produces the wrong link.
 */

function siteOrigin(): string {
  return window.location.origin;
}

export function hostSessionPath(sessionId: string): string {
  return `/session/${sessionId}/host`;
}

export function playerSessionPath(sessionId: string): string {
  return `/session/${sessionId}/player`;
}

/** Absolute URL a phone or browser can open to join as a player. */
export function playerSessionUrl(sessionId: string): string {
  return new URL(playerSessionPath(sessionId), siteOrigin()).toString();
}

/**
 * Extracts the session id from the current location when it is a session route.
 * Returns null outside session routes rather than guessing.
 */
export function sessionIdFromPath(pathname: string = window.location.pathname): string | null {
  const match = pathname.match(/^\/session\/([^/]+)\/(?:host|player)(?:\/|$)/);
  return match?.[1] ?? null;
}
